import * as angular from 'angular';

declare global {
  interface Window {
    __karma__: object;
  }
}

export function bootstrapModule(moduleName: string) {
  if (!window.__karma__) {
    angular.bootstrap(document, [moduleName]);
  }
}
